import firstImg from '@/assets/images/man-in-stall-stroking-horse.webp';
import secondImg from '@/assets/images/girl-stroking-horse-side.webp';
import thirdImg from '@/assets/images/man-facing-horse-forehead.webp';
import fourthImg from '@/assets/images/happy-girl-hugging-horse.webp';
import fifthImg from '@/assets/images/girl-holding-horse-chin.webp';
export const MockCards = {
    programData: [
        {
            image: firstImg,
            title: 'Коні лікують Літо 2025',
            subtitle: 'Ветеранська програма',
            description:
                'Зменшення рівня стресу, тривоги та ПТСР у ветеранів, повернення відчуття контролю, розвиток внутрішньої сили та опори.',
        },
        {
            image: secondImg,
            title: 'Коні лікують Літо 2025',
            subtitle: 'Ветеранська програма',
            description:
                'Зменшення рівня стресу, тривоги та ПТСР у ветеранів, повернення відчуття контролю, розвиток внутрішньої сили та опори.',
        },
        {
            image: thirdImg,
            title: 'Коні лікують Літо 2025',
            subtitle: 'Ветеранська програма',
            description:
                'Зменшення рівня стресу, тривоги та ПТСР у ветеранів, повернення відчуття контролю, розвиток внутрішньої сили та опори.',
        },
        {
            image: fourthImg,
            title: 'Коні лікують Літо 2025',
            subtitle: 'Ветеранська програма',
            description:
                'Зменшення рівня стресу, тривоги та ПТСР у ветеранів, повернення відчуття контролю, розвиток внутрішньої сили та опори.',
        },
        {
            image: fifthImg,
            title: 'Коні лікують Літо 2025',
            subtitle: 'Ветеранська програма',
            description:
                'Зменшення рівня стресу, тривоги та ПТСР у ветеранів, повернення відчуття контролю, розвиток внутрішньої сили та опори.',
        },
    ],
};
export const MockQuestions = {
    questions: [
        {
            question: 'Як долучитись до програми?',
            answer: "Потрібно заповнити коротку анкету або написати координатору через форму на сайті. Після цього ми зв'яжемось для уточнення деталей.",
        },
        {
            question: 'Як проходять терапевтичні сесії?',
            answer: "Потрібно заповнити коротку анкету або написати координатору через форму на сайті. Після цього ми зв'яжемось для уточнення деталей.",
        },
        {
            question: 'Де проходять програми?',
            answer: "Потрібно заповнити коротку анкету або написати координатору через форму на сайті. Після цього ми зв'яжемось для уточнення деталей.",
        },
    ],
};
export const mockPrograms = {
    programsCategories: [
        { id: 1, name: 'Category 1' },
        { id: 2, name: 'Category 2' },
    ],
    programsData: [
        {
            id: 1,
            image: null,
            name: 'Program A',
            description: 'Description A',
            categories: [{ id: 1, name: 'Category 1' }],
        },
        {
            id: 2,
            image: null,
            name: 'Program B',
            description: 'Description B',
            categories: [{ id: 2, name: 'Category 2' }],
        },
    ],
};
